import { useEffect } from 'react';
import { AText, Box } from '@alf/uikit';
import { PersonalOfficeWrapper } from '@namespace/account';
import { useGeneralRoutes } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { Image } from '@namespace/icons2';
import { useRouteParams } from '@namespace/router';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';

import styles from './index.module.css';

const { FETCH_MESSAGE_DETAILS } = notificationCenterActions;

export const NotificationMessageDetails = () => {
  const { messageDetails, isFetchingMessageDetails } =
    useNotificationCenterStore(['messageDetails', 'isFetchingMessageDetails']);
  const { t, f } = useI18n();
  const { messagePreview } = useGeneralRoutes();
  const { messageId } = useRouteParams(`${messagePreview}/:messageId`);
  const DATE_FORMATS_TYPES = f.getFormats();
  const { date, title, paContent } = messageDetails;

  useEffect(() => {
    if (messageId) {
      FETCH_MESSAGE_DETAILS(messageId);
    }
  }, [FETCH_MESSAGE_DETAILS, messageId]);

  return (
    !isFetchingMessageDetails && (
      <Box component={PersonalOfficeWrapper} align="start">
        <Box direction="column" className={styles.container}>
          <Box direction="column" className={styles.textContainer}>
            <AText
              breed="B"
              size="xl"
              color="txt_color_3"
              className={styles.textContainer}
            >
              {title}
            </AText>
            <Box>
              <AText
                size="s"
                color="po_txt_color_1"
                className={styles.infoLabel}
              >
                {`${t('messages.preview.date')}: `}
              </AText>
              <AText breed="B" size="s" color="po_txt_color_1">
                {f
                  .getDateTime({
                    date: date * 1000
                  })
                  .toFormat(DATE_FORMATS_TYPES.dd_MM_yyyy)}
              </AText>
            </Box>
          </Box>
          <AText
            size="m"
            color="txt_color_3"
            dangerouslySetInnerHTML={{ __html: paContent }}
          />
        </Box>
        <Box justify="end" className={styles.imageWrap}>
          <Image name="general/email" width="170px" height="170px" alt="" />
        </Box>
      </Box>
    )
  );
};
